import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que reseteea el scroll a la parte superior cuando cambias de ruta
 * Soluciona el problema de que el scroll queda en la posición anterior
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reseteear el scroll de la ventana principal
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Este componente no renderiza nada
};

export default ScrollToTop;
